<template>
	<div id="top" >
		<v-container style="max-width:1024px">
			<div class="elevation-2 content">
				<div v-if="viewedDevice.id !== 0">
					<div style="padding-top:8px" />
					<router-link :to="lng.listPath">
						<v-btn flat class="back-button">
							<v-icon>chevron_left</v-icon> {{ lng.back }}
						</v-btn>
					</router-link>
				</div>
				<h1>{{ viewedDevice.title }}</h1>

				<div v-if="language === 'en'">
					<div v-if="viewedDevice.id === 0">
						<v-container>
							<router-link :to="lng.listPath + '/HAQCS-Monitor'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/haqcs.webp" type="image/webp" />
										<img class="haqcs-height no-shadow" src="/static/img/offer/haqcs.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">HAQCS-Monitor</div>
											<p> Air quality monitor and controller for decentralized ventilation and humidification. </p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>
							
							<router-link :to="lng.listPath + '/Ambientika-AUTO'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/Ambientika+HAQCS.webp" type="image/webp" />
										<img class="ambientika-auto-height no-shadow" src="/static/img/offer/Ambientika+HAQCS.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Ambientika AUTO</div>
											<p>Ventilation unit for fully automatic, demand-oriented, decentralized ventilation systems. Through optimized control via the HAQCS monitor, it saves heating energy more effectively than when controlled by humans.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>
							
							<router-link :to="lng.listPath + '/HRU-WALL-WI'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/HW_app_moni.webp" type="image/webp" />
										<img class="hru-wall-wi-height no-shadow" src="/static/img/offer/HW_app_moni.jpg" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">HRU-WALL-WI</div>
											<p>Ventilation unit that is factory-equipped with HAQCS compatibility and can also be manually controlled via a smartphone app.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Marley-MEnV-HAQCS-Edition'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/marley-MEnV-HAQCS-edition.webp" type="image/webp" />
										<img class="marley-haqcs-edition-height no-shadow" src="/static/img/offer/marley-MEnV-HAQCS-edition.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Marley MEnV HAQCS-Edition</div>
											<p> Successor to the popular Marley MEnV 180 model. The HAQCS edition has HAQCS compatibility. </p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Upgrade-Marley-MEnV-180'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/upgrade-marley-MEnV180.webp" type="image/webp" />
										<img class="upgrade-marley-menv-180-height" src="/static/img/offer/upgrade-marley-MEnV180.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title"> Upgrade for Marley MEnV 180 to HAQCS </div>
											<p> Set of control boards for the popular ventilation units with heat recovery Marley MEnV 180. After replacing the boards, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. </p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Upgrade-Prana-150-200'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/upgrade-prana150-200.webp" type="image/webp" />
										<img class="upgrade-prana-150-200-height" src="/static/img/offer/upgrade-prana150-200.jpg" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title"> Upgrade for Prana 150/200 </div>
											<p> Control board for the decentralized ventilation units with heat recovery Prana 150, 200C, 200G. After replacing the board, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. </p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/HAQCS-Unibox'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/Unibox.webp" type="image/webp" />
										<img class="unibox-height" src="/static/img/offer/Unibox.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">HAQCS-Unibox</div>
											<p> Power controller for simple exhaust fans for 230 V, which do not have their own regulation and control. The power supply to the fan is looped through the Unibox. </p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0xa778">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/haqcs.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/haqcs.png" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p"> Air quality monitor and controller for decentralized ventilation and humidification. </p>

							<h2> Functions: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Measurement of air quality and indoor climate </li>
									<li> Display of current values ​​as numbers and graphically </li>
									<li> Display the trends of the last 3 or 12 hours </li>
									<li> Air quality can be read even when the screen is switched off </li>
									<li> Alarms at threshold values ​​of CO<sub>2</sub> optically and acoustically </li>
									<li> Control of compatible ventilation units (up to 16 at a time), 3 automatic modes, night mode, intensive mode, manual control, automatic dehumidification mode, summer mode </li>
									<li> Control of compatible humidifiers </li>
									<li> Retains settings after a power failure </li>
									<li> Does not require a router as it works without being connected to the Internet </li>
									<li> Can hang on the wall or stand on horizontal surfaces </li>
									<li> Wireless communication with devices with WiFi technology (no IP protocol) </li>
									<li> Range corresponds to WiFi </li>
								</ul>
							</p>

							<h2> Technical data: </h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter"> Internal sensors </div>
									<div class="value">
										<ul class="narrow">
											<li> Carbon dioxide CO<sub>2</sub> </li>
											<li> TVOC </li>
											<li> Temperature </li>
											<li> Relative humidity </li>
											<li> Light sensor </li>
										</ul>
									</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter"> Screen </div>
									<div class="value"> 3.5 inch color screen 480 x 320 pixels <br> touch sensitive </div>
								</div>
								<div class="table table-even">
									<div class="parameter"> LED display </div>
									<div class="value"> 8 RGB LEDs </div>
								</div>
								<div class="table table-uneven">
									<div class="parameter"> Power supply </div>
									<div class="value"> 5 V USB power supply, micro-USB connections from below and from the side </div>
								</div>
								<div class="table table-even">
									<div class="parameter"> Colors </div>
									<div class="value"> Bordeaux, dark green, gray </div>
								</div>
							</div>

							<h2> Scope of delivery: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li>HAQCS-Monitor</li>
									<li> USB power supply </li>
									<li>Micro-USB cable</li>
								</ul>
							</p>
						</v-container>
					</div>
					
					<div v-if="viewedDevice.id === 0x1bcf">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/Ambientika+HAQCS-high-quality.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/Ambientika+HAQCS.png" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p">Upgrade of an Ambientika brand model to HAQCS compatibility. Together with the HAQCS monitor, it forms a fully automated, demand-oriented ventilation system that optimizes ventilation and thus saves heating energy, something humans cannot do.</p>
							<p class="p-p" style="text-align: center;">This makes it our top model.</p>

							<h2>Features:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Communicates with HAQCS monitor and is regulated by it</li>
									<li>Continuous control of ventilation intensity</li>
									<li>Automatically closes the air duct when not ventilating</li>
									<li>Displays current ventilation intensity with a colored LED</li>
									<li>Requires a HAQCS monitor for control</li>
									<li>Equipped with G3 filter</li>
									<li>All service activities can be performed from the inside</li>
									<li>Automatically adjusts the brightness of the display</li>
								</ul>
							</p>

							<h2>Technical specifikations:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Airflow:</div>
									<div class="value">Continuously up to 60 m³/h</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Power consumption:</div>
									<div class="value">Below 7 Watts</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Noise level:</div>
									<div class="value">30 dB(A) at maximum speed</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Heat recovery:</div>
									<div class="value">Up to 93%</div>
								</div>
							</div>
						</v-container>
					</div>
					
					<div v-if="viewedDevice.id === 0x0f43">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/HW_app_moni-high-quality.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/HW_app_moni.jpg" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p">Ventilation device from the Alnor brand, factory-equipped with HAQCS compatibility, thus ventilating fully automatically based on demand and optimally saving heating energy. For budget solutions, it can also be manually controlled via a smartphone app.</p>

							<h2>Advantages:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>HAQCS compatibility - retrofittable automatic demand-driven ventilation control based on measurements of indoor air quality in conjunction with the HAQCS monitor.</li>
									<li>Easy installation in exterior walls with minimal wiring.</li>
									<li>High delivery capacity: 20, 40, and 60 m³/h of air.</li>
									<li>Built-in humidity sensor for automatic dehumidification when needed.</li>
									<li>Quiet operation.</li>
									<li>Free app for control.</li>
									<li>Easy to clean.</li>
								</ul>
							</p>
							
							<h2>Control:</h2>
							<p class="p-p">Controlled by the HAQCS monitor based on data from its sensors. Always fresh air according to demand and energy savings. Automatic. Alternatively, manual control with the free WallAIR app.</p>
							
							<h2>Service:</h2>
							<p class="p-p">All service and maintenance tasks can be conveniently and affordably performed from the interior. No need for external scaffolding.</p>

							<h2>Technical Specifications:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">3 performance levels:</div>
									<div class="value">20, 40, 60 m³/h</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Exterior wall thickness:</div>
									<div class="value">200 – 560 mm</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Power consumption:</div>
									<div class="value">1.4 – 3.8 watts</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Sound pressure level (3 m):</div>
									<div class="value">10 – 26 dB(A)</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Sound insulation from the outside:</div>
									<div class="value">39 dB (equivalent to window class 3 according to VDI 2719)</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Heat recovery:</div>
									<div class="value">Max. 82%, Average 74.3%</div>
								</div>
							</div>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0x7b90">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/marley-MEnV-HAQCS-edition.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/marley-MEnV-HAQCS-edition.png" />
							</picture>

							<p class="p-p"> Successor to the popular Marley MEnV 180 model. The HAQCS edition has HAQCS compatibility. </p>

							<h2> Functions: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Communicates with and is regulated by the HAQCS monitor </li>
									<li> Shows current ventilation intensity with a colored LED </li>
									<li> Requires a HAQCS monitor for control </li>
									<li> Has G3 and G2 filters, optionally even F7 filters </li>
									<li> All service activities can be carried out from the inside </li>
									<li> Automatically controls the brightness of the display </li>
								</ul>
							</p>

							<h2> Technical data: </h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter"> Air flow </div>
									<div class="value"> 16 - 25 or 37 m³ / h depending on the level </div>
								</div>
								<div class="table table-uneven">
									<div class="parameter"> Power consumption </div>
									<div class="value"> 3.5 - 5.0 - 7.5 watts depending on the level </div>
								</div>
								<div class="table table-even">
									<div class="parameter"> Volume </div>
									<div class="value"> 22 - 29 - 35 dB(A) depending on the level </div>
								</div>
								<div class="table table-uneven">
									<div class="parameter"> Heat recovery </div>
									<div class="value"> Max 85%, average 79.1% </div>
								</div>
							</div>

							<h2> Scope of delivery: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Marley MEnV HAQCS-Edition</li>
									<li> Filter set for 2 years </li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0x217d">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/upgrade-marley-MEnV180.webp" type="image/webp" />
								<img class="p-img" src="../../static/img/offer/upgrade-marley-MEnV180.jpg" />
							</picture>

							<p class="p-p"> Set of control boards for the popular ventilation units with heat recovery Marley MEnV 180. After replacing the boards, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. </p>

							<h2> Functions: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Communicates with HAQCS-Monitor </li>
									<li> Controls the fan and the indicator LED </li>
									<li> Monitors the operating time and reminds you to change the filter </li>
								</ul>
							</p>

							<h2> Technical data: </h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter"> Power consumption </div>
									<div class="value">0,30  - 0,35 W during standby</div>
								</div>
							</div>

							<h2> Scope of delivery: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Controls for 2 devices </li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id == 0xacdc">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/upgrade-prana150-200.webp" type="image/webp" />
								<img class="p-img" src="../../static/img/offer/upgrade-prana150-200.jpg" />
							</picture>

							<p class="p-p"> Control board for the decentralized ventilation units with heat recovery Prana 150, 200C, 200G. After replacing the board, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. </p>

							<h2> Functions: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Communicates with HAQCS monitor or remote control </li>
									<li> Controls the fans </li>
									<li> Allows all automatic modes, manual control, night mode, intensive mode and summer mode </li>
									<li> Displays the ventilation intensity in 1% increments </li>
									<li> Automatically controls the brightness of the display </li>
								</ul>
							</p>

							<!-- <h2> Technical data: </h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter"> Power consumption </div>
									<div class="value">0,30  - 0,35 W in Stand-by</div>
								</div>
							</div> -->

							<h2> Scope of delivery: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Control board for 1 device </li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id == 0x75ab">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/Unibox.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/Unibox.png" />
							</picture>

							<p class="p-p"> Power controller for simple exhaust fans for 230 V, which do not have their own regulation and control. The power supply to the fan is looped through the Unibox.</p>

							<h2> Functions: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Communicates with HAQCS-Monitor </li>
									<li> Controls the connected fans </li>
									<li> Displays current ventilation intensity in 1% increments </li>
									<li> Automatically controls the brightness of the display </li>
								</ul>
							</p>

							<h2> Technical data: </h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter"> Control power </div>
									<div class="value">Max:  150 W</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter"> Input voltage </div>
									<div class="value"> 230 V, 110 V </div>
								</div>
								<div class="table table-even">
									<div class="parameter"> Frequency </div>
									<div class="value"> 50 Hz, 60 Hz </div>
								</div>
							</div>

							<h2> Scope of delivery: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> HAQCS Unibox with mounting material </li>
								</ul>
							</p>
						</v-container>
					</div>
				</div>

				<div v-if="language === 'de'">
					<div v-if="viewedDevice.id === 0">
						<v-container>
							<router-link :to="lng.listPath + '/HAQCS-Monitor'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/haqcs.webp" type="image/webp" />
										<img class="haqcs-height no-shadow" src="/static/img/offer/haqcs.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">HAQCS-Monitor</div>
											<p>Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO<sub>2</sub>, VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Ambientika-AUTO'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/Ambientika+HAQCS.webp" type="image/webp" />
										<img class="ambientika-auto-height no-shadow" src="/static/img/offer/Ambientika+HAQCS.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Ambientika AUTO</div>
											<p>Lüftungsgerät für vollautomatische, bedarfsorientierte, dezentrale Lüftungssysteme. Durch optimierte Steuerung per HAQCS-Monitor spart Heizungswärme effektiver als bei Steuerung durch Menschen.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>
							
							<router-link :to="lng.listPath + '/HRU-WALL-WI'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/HW_app_moni.webp" type="image/webp" />
										<img class="hru-wall-wi-height no-shadow" src="/static/img/offer/HW_app_moni.jpg" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">HRU-WALL-WI</div>
											<p>Lüftungsgerät das vom Werk aus HAQCS-kompatibel ist und auch manuell, per Smartphone-App gesteuert werden kann. </p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Marley-MEnV-HAQCS-Edition'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/marley-MEnV-HAQCS-edition.webp" type="image/webp" />
										<img class="marley-haqcs-edition-height no-shadow" src="/static/img/offer/marley-MEnV-HAQCS-edition.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Marley MEnV HAQCS-Edition</div>
											<p>Nachfolger des populären Modells Marley MEnV 180. Die HAQCS-Edition verfügt über HAQCS-kompatibilität.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Upgrade-Marley-MEnV-180'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/upgrade-marley-MEnV180.webp" type="image/webp" />
										<img class="upgrade-marley-menv-180-height" src="/static/img/offer/upgrade-marley-MEnV180.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Upgrade für Marley MEnV 180 auf HAQCS</div>
											<p>Satz Steuerplatinen für die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180. Nach Austausch der Platinen werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Upgrade-Prana-150-200'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/upgrade-prana150-200.webp" type="image/webp" />
										<img class="upgrade-prana-150-200-height" src="/static/img/offer/upgrade-prana150-200.jpg" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Upgrade für Prana 150 / 200</div>
											<p>Steuerplatine für die dezentralen Lüftungsgeräte mit Wärmerückgewinnung Prana 150, 200C, 200G. Nach Austausch der Platine werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/HAQCS-Unibox'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/Unibox.webp" type="image/webp" />
										<img class="unibox-height" src="/static/img/offer/Unibox.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">HAQCS-Unibox</div>
											<p>Leistungsregler für einfache Abluftventilatoren für 230 V, die keine eigene Regelung und Steuerung besitzen. Die Stromversorgung zum Ventilator wird durch die Unibox durchgeschleift.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0xa778">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/haqcs.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/haqcs.png" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p">Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO<sub>2</sub>, VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung. </p>

							<h2>Funktionen:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Messung der Luftqualität und des Raumklimas</li>
									<li>Anzeige aktueller Werte als Zahlen und grafisch</li>
									<li>Anzeige der Trends der letzten 3 oder 12 Stunden</li>
									<li>Luftqualität auch beim abgeschalteten Bildschirm ablesbar</li>
									<li>Alarme bei Schwellenwerten von CO<sub>2</sub> optisch und akustisch</li>
									<li>Regelung von kompatiblen Lüftungsgeräten (bis zu 16 gleichzeitig), 3 automatische Modi, Nachtmodus, Intensivmodus, manuelle Steuerung, Automatischer Entfeuchtungsmodus, Sommermodus</li>
									<li>Regelung von kompatiblen Luftbefeuchtern </li>
									<li>Behält Einstellungen nach einem Stromausfall</li>
									<li>Benötigt keinen Router, keine Verbindung mit dem Internet</li>
									<li>Kann an der Wand hängen, oder auf waagerechten Flächen stehen</li>
									<li>Drahtlose Kommunikation mit den Geräten mit WiFi-Technik (kein IP-Protokoll)</li>
									<li>Reichweite entspricht WiFi</li>
								</ul>
							</p>

							<h2>Technische Daten:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Interne Sensoren</div>
									<div class="value">
										<ul class="narrow">
											<li>Kohlendioxid CO<sub>2</sub></li>
											<li>TVOC</li>
											<li>Temperatur</li>
											<li>Relative Feuchte</li>
											<li>Lichtsensor</li>
										</ul>
									</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Bildschirm</div>
									<div class="value">3,5 Zoll Farbbildschirm 480 x 320 Pixel<br>Berührungssensitiv</div>
								</div>
								<div class="table table-even">
									<div class="parameter">LED-Anzeige</div>
									<div class="value">8 RGB Leuchtdioden</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Stromversorgung</div>
									<div class="value">5 V USB-Netzteil, Anschlüsse micro-USB von unten und seitlich</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Farben</div>
									<div class="value">Bordeaux, dunkel grün, grau</div>
								</div>
							</div>

							<h2>Lieferumfang:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>HAQCS-Monitor</li>
									<li>USB-Netzteil</li>
									<li>Micro-USB Kabel</li>
								</ul>
							</p>
						</v-container>
					</div>
					
					<div v-if="viewedDevice.id === 0x1bcf">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/Ambientika+HAQCS-high-quality.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/Ambientika+HAQCS.png" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p">Upgrade eines Models der Marke Ambientika zu HAQCS-Kompatibilität. Zusammen mit dem HAQCS-Monitor bildet vollautomatisches, bedarfsorientiertes  Lüftungssystem das optimiert die Lüftung und spart dadurch Heizungsenergie, was Menschen nicht können. </p>
							<p class="p-p">Dadurch ist das unser Top-Model.</p>

							<h2>Funktionen:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Kommuniziert mit HAQCS-Monitor und wird von ihm geregelt</li>
									<li>Stufenlose Regelung der Lüftungsintensität</li>
									<li>Verschließt automatisch den Luftkanal wenn nicht gelüftet wird</li>
									<li>Zeigt aktuelle Lüftungsintensität mit einer Farbigen LED an</li>
									<li>Benötigt einen HAQCS-Monitor zur Steuerung</li>
									<li>Verfügt über G3 – Filter</li>
									<li>Alle Service-Tätigkeiten durchführbar von innen</li>
									<li>Regelt die Helligkeit der Anzeige automatisch</li>
								</ul>
							</p>

							<h2>Technische Daten:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Luftdurchsatz</div>
									<div class="value">Stufenlos bis 60 m³/h</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Stromverbrauch</div>
									<div class="value">Unter 7 Watt</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Lautstärke</div>
									<div class="value">30 dB(A) bei max. Geschwindigkeit</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Wärmerückgewinnung</div>
									<div class="value">bis 93%</div>
								</div>
							</div>
						</v-container>
					</div>
					
					<div v-if="viewedDevice.id === 0x0f43">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/HW_app_moni-high-quality.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/HW_app_moni.jpg" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p">Lüftungsgerät der Marke Alnor, das vom Werk aus HAQCS-Kompatibel ist und daher vollautomatisch bedarfsgeführt lüftet und spart optimal die Heizwärme. Für Budgetlösungen kann es auch manuell per Smartphone-App gesteuert werden.</p>

							<h2>Vorteile:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li><b>HAQCS-Kompatibilität</b> - nachrüstbare automatische bedarfsgerechte Regelung der Lüftung anhand von Messungen der Luftqualität im Raum in Verbindung mit HAQCS-Monitor</li>
									<li>Einfache Montage in den Außenwänden mit minimaler Verkabelung</li>
									<li>Große Förderleistung 20, 40 und 60 m³/h Luft</li>
									<li>eingebauter Feuchtesensor zur automatischen Entfeuchtung bei Bedarf.</li>
									<li>Leise</li>
									<li>kostenlose App zur Steuerung</li>
									<li>Leicht zu reinigen</li>
								</ul>
							</p>
							
							<h2>Steuerung</h2>
							<p class="p-p">Steuerung durch den HAQCS-Monitor anhand der Daten aus seinen Sensoren. Immer frische Luft entsprechend dem Bedarf und Energieeinsparung. Automatisch.</p>
							<p class="p-p">Alternativ manuelle Steuerung mit der kostenlosen App WallAIR.</p>
							
							<h2>Service von Innen</h2>
							<p class="p-p">Sämtliche Service- und Wartungsarbeiten lassen sich bequem und günstig vom Innenraum her durchführen. Es besteht keine Notwendigkeit für Außengerüste.</p>

							<h2>Technical Specifications:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">3 Leistungsstufen</div>
									<div class="value">20, 40, 60 m³/h</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Außenwandstärken:</div>
									<div class="value">200 – 560 mm</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Leistungsaufnahme:</div>
									<div class="value">1,4 –3,8 Watt</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Schalldruckpegel (3 m):</div>
									<div class="value">10 – 26 dB(A)</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Schalldämmung von außen:</div>
									<div class="value">39 dB (entspricht Fensterklasse 3 nach VDI 2719)</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Wärmerückgewinnung:</div>
									<div class="value">Max. 82%, Mittel 74,3%</div>
								</div>
							</div>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0x7b90">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/marley-MEnV-HAQCS-edition.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/marley-MEnV-HAQCS-edition.png" />
							</picture>

							<p class="p-p">Nachfolger des populären Modells Marley MEnV 180. Die HAQCS-Edition verfügt über HAQCS-kompatibilität. </p>

							<h2>Funktionen:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Kommuniziert mit HAQCS-Monitor und wird von ihm geregelt</li>
									<li>Zeigt aktuelle Lüftungsintensität mit einer Farbigen LED an</li>
									<li>Benötigt einen HAQCS-Monitor zur Steuerung</li>
									<li>Verfügt über G3 und G2 – Filter, optional sogar F7 – Filter</li>
									<li>Alle Service-Tätigkeiten durchführbar von innen</li>
									<li>Regelt die Helligkeit der Anzeige automatisch</li>
								</ul>
							</p>

							<h2>Technische Daten:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Luftdurchsatz</div>
									<div class="value">16  -  25  oder 37 m³/h je nach Stufe</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Stromverbrauch</div>
									<div class="value">3,5  -   5,0  -  7,5 Watt je nach Stufe</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Lautstärke</div>
									<div class="value">22  -  29  -  35  dB(A) je nach Stufe</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Wärmerückgewinnung</div>
									<div class="value">Max 85%,  Durchschnittlich 79,1%</div>
								</div>
							</div>

							<h2>Lieferumfang:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Marley MEnV HAQCS-Edition</li>
									<li>Filtersatz für 2 Jahre</li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0x217d">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/upgrade-marley-MEnV180.webp" type="image/webp" />
								<img class="p-img" src="../../static/img/offer/upgrade-marley-MEnV180.jpg" />
							</picture>

							<p class="p-p">Satz Steuerplatinen für die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180. Nach Austausch der Platinen werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.</p>

							<h2>Funktionen:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Kommuniziert mit HAQCS-Monitor</li>
									<li>Steuert den Lüfter und die Anzeigen-LED</li>
									<li>Überwacht die Betriebszeit und erinnert an Filterwechsel</li>
								</ul>
							</p>

							<h2>Technische Daten:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Stromverbrauch</div>
									<div class="value">0,30  - 0,35 W in Stand-by</div>
								</div>
							</div>

							<h2>Lieferumfang:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Steuerungen für 2 Geräte</li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id == 0xacdc">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/upgrade-prana150-200.webp" type="image/webp" />
								<img class="p-img" src="../../static/img/offer/upgrade-prana150-200.jpg" />
							</picture>

							<p class="p-p">Steuerplatine für die dezentralen Lüftungsgeräte mit Wärmerückgewinnung Prana 150, 200C, 200G. Nach Austausch der Platine werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.</p>

							<h2>Funktionen:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Kommuniziert mit HAQCS-Monitor oder Fernbedienung</li>
									<li>Steuert die Lüfter</li>
									<li>Erlaubt alle Automatikmodi, manuelle Steuerung, Nachtmodus, Intensivmodus und Sommermodus</li>
									<li>Zeigt die Lüftungsintensität in 1%-Schritten an</li>
									<li>Regelt die Helligkeit der Anzeige automatisch</li>
								</ul>
							</p>

							<!-- <h2>Technische Daten:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Stromverbrauch</div>
									<div class="value">0,30  - 0,35 W in Stand-by</div>
								</div>
							</div> -->

							<h2>Lieferumfang:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Steuerung für 1 Gerät</li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id == 0x75ab">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/Unibox.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/Unibox.png" />
							</picture>

							<p class="p-p">Leistungsregler für einfache Abluftventilatoren für 230 V, die keine eigene Regelung und Steuerung besitzen. Die Stromversorgung zum Ventilator wird durch die Unibox durchgeschleift.</p>

							<h2>Funktionen:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Kommuniziert mit HAQCS-Monitor</li>
									<li>Steuert die angeschlossenen Ventilatoren</li>
									<li>Zeigt aktuelle Lüftungsintensität in 1%-Schritten an</li>
									<li>Regelt die Helligkeit der Anzeige automatisch</li>
								</ul>
							</p>

							<h2>Technische Daten:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Regelleistung </div>
									<div class="value">Max:  150 W</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Eingangspannung </div>
									<div class="value">230 V, 110 V</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Frequenz </div>
									<div class="value">50 Hz, 60 Hz</div>
								</div>
							</div>

							<h2>Lieferumfang:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>HAQCS-Unibox mit Montagematerial</li>
								</ul>
							</p>
						</v-container>
					</div>
				</div>

				<div v-if="language === 'pl'">
					<div v-if="viewedDevice.id === 0">
						<v-container>
							<router-link :to="lng.listPath + '/HAQCS-Monitor'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/haqcs.webp" type="image/webp" />
										<img class="haqcs-height no-shadow" src="/static/img/offer/haqcs.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Monitor HAQCS</div>
											<p>Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>
							
							<router-link :to="lng.listPath + '/Ambientika-AUTO'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/Ambientika+HAQCS.webp" type="image/webp" />
										<img class="ambientika-auto-height no-shadow" src="/static/img/offer/Ambientika+HAQCS.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Ambientika AUTO</div>
											<p>Urządzenie wentylacyjne do w pełni automatycznych, zdecentralizowanych systemów wentylacyjnych. Dzięki sterowaniu według aktualnego zapotrzebowania optymalizowanej za pomocą monitora HAQCS, oszczędza energię grzewczą bardziej efektywnie niż w przypadku sterowania przez ludzi.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>
							
							<router-link :to="lng.listPath + '/HRU-WALL-WI'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/HW_app_moni.webp" type="image/webp" />
										<img class="hru-wall-wi-height no-shadow" src="/static/img/offer/HW_app_moni.jpg" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">HRU-WALL-WI</div>
											<p>Urządzenie wentylacyjne, które jest fabrycznie kompatybilne z systemem HAQCS i może być również sterowane ręcznie za pomocą aplikacji na smartfona.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Marley-MEnV-Edycja-HAQCS'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/marley-MEnV-HAQCS-edition.webp" type="image/webp" />
										<img class="marley-haqcs-edition-height no-shadow" src="/static/img/offer/marley-MEnV-HAQCS-edition.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Marley MEnV Edycja HAQCS</div>
											<p>Następca popularnego modelu Marley MEnV 180. Urządzenie jest kompatybilne z HAQCS.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Ulepszenie-Marley-MEnV-180'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/upgrade-marley-MEnV180.webp" type="image/webp" />
										<img class="upgrade-marley-menv-180-height" src="/static/img/offer/upgrade-marley-MEnV180.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Ulepszenie dla Marley MEnV 180 na HAQCS</div>
											<p>Zestaw płytek sterownika do popularnych urządzeń wentylacyjnych z odzyskiem ciepła Marley MEnV 180. Po wymianie płytek urządzenia stają się kompatybilne z HAQCS i mogą być sterowane automatycznie przez HAQCS-Monitor odpowiednio do rzeczywistych potrzeb.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/Ulepszenie-Prana-150-200'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/upgrade-prana150-200.webp" type="image/webp" />
										<img class="upgrade-prana-150-200-height" src="/static/img/offer/upgrade-prana150-200.jpg" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">Ulepszenie dla Prana 150 / 200</div>
											<p>Centrala sterująca do zdecentralizowanych urządzeń wentylacyjnych z odzyskiem ciepła Prana 150, 200C, 200G. Po wymianie płytki urządzenia stają się kompatybilne z HAQCS i mogą być kontrolowane automatycznie w zależności od potrzeb przez HAQCS-Monitor.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>

							<router-link :to="lng.listPath + '/HAQCS-Unibox'" tag="div">
								<div class="tile noselect" @click="scrollToTop">
									<picture>
										<source srcset="/static/img/offer/Unibox.webp" type="image/webp" />
										<img class="unibox-height" src="/static/img/offer/Unibox.png" />
									</picture>
									<div class="text-container_">
										<div class="text">
											<div class="device-title">HAQCS-Unibox</div>
											<p>Regulator wydajności dla prostych wentylatorów wyciągowych na 230 V, które nie mają własnej regulacji i sterowania. Unibox jest wpinany w przewód zasilający wentylatora.</p>
										</div>
									</div>
									<div class="icon-container_">
										<div class="icon">
											<v-icon>chevron_right</v-icon>
										</div>
									</div>
								</div>
							</router-link>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0xa778">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/haqcs.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/haqcs.png" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p">Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.</p>

							<h2>Funkcje:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Pomiar jakości powietrza i klimatu w pomieszczeniu</li>
									<li>Wyświetlanie bieżących wartości jako liczb i graficznie</li>
									<li>Wyświetla trendy z ostatnich 3 lub 12 godzin</li>
									<li>Jakość powietrza można również odczytać, gdy ekran jest wyłączony</li>
									<li>Alarmy przy wartościach progowych CO<sub>2</sub> optycznie i akustycznie</li>
									<li>Sterowanie kompatybilnymi urządzeniami wentylacyjnymi (do 16 jednocześnie), 3 tryby automatyczne, tryb nocny, tryb intensywny, sterowanie ręczne, tryb automatycznego osuszania, tryb letni</li>
									<li>Kontrola kompatybilnych nawilżaczy</li>
									<li>Zachowuje ustawienia po awarii zasilania</li>
									<li>Nie wymaga routera, nie ma połączenia z Internetem</li>
									<li>Może wisieć na ścianie lub stać na poziomych powierzchniach</li>
									<li>Bezprzewodowa komunikacja z urządzeniami z technologią WiFi (bez protokołu IP)</li>
									<li>Zasięg odpowiada Wi-Fi</li>
								</ul>
							</p>

							<h2>Dane techniczne:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Czujniki wewnętrzne</div>
									<div class="value">
										<ul class="narrow">
											<li>Dwutlenek węgla CO<sub>2</sub></li>
											<li>TVOC</li>
											<li>Temperatura</li>
											<li>Wilgotność względna</li>
											<li>Czujnik światła</li>
										</ul>
									</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Screen</div>
									<div class="value">Kolorowy ekran 3,5 cala 480 x 320 pikseli <br> wrażliwy na dotyk</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Wyświetlacz LED</div>
									<div class="value">8 diody LED RGB</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Zasilacz</div>
									<div class="value">Zasilacz USB 5 V, złącza micro-USB od dołu i z boku</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Kolory</div>
									<div class="value">Bordeaux, ciemnozielony, szary</div>
								</div>
							</div>

							<h2>Zakres dostawy:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>HAQCS-Monitor</li>
									<li>Zasilacz USB</li>
									<li>Kabel Micro-USB</li>
								</ul>
							</p>
						</v-container>
					</div>
					
					<div v-if="viewedDevice.id === 0x1bcf">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/Ambientika+HAQCS-high-quality.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/Ambientika+HAQCS.png" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p">Aktualizacja modelu marki Ambientika do zgodności z HAQCS. Razem z monitorem HAQCS tworzy w pełni zautomatyzowany, dostosowany do zapotrzebowania system wentylacji, który optymalizuje wentylację, co pozwala oszczędzać energię ogrzewania, czego ludzie sami nie są w stanie zrobić.</p>
							<p class="p-p" style="text-align: center;">To sprawia, że jest to nasz najlepszy model.</p>

							<h2>Funkcje:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Komunikuje się z monitorem HAQCS i jest przez niego regulowany</li>
									<li>Bezstopniowa regulacja intensywności wentylacji</li>
									<li>Automatycznie zamyka kanał powietrzny, gdy nie jest używany</li>
									<li>Wyświetla aktualną intensywność wentylacji za pomocą kolorowej diody LED</li>
									<li>Wymaga monitora HAQCS do sterowania</li>
									<li>Wyposażony w filtr G3</li>
									<li>Wszystkie czynności serwisowe możliwe do wykonania od wewnątrz</li>
									<li>Automatycznie reguluje jasność wyświetlacza</li>
								</ul>
							</p>

							<h2>Dane techniczne:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Przepływ powietrza:</div>
									<div class="value">bezstopniowy do 60 m³/h</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Zużycie energii:</div>
									<div class="value">poniżej 7 watów</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Poziom hałasu:</div>
									<div class="value">30 dB(A) przy maksymalnej prędkości</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Odzysk ciepła:</div>
									<div class="value">do 93%</div>
								</div>
							</div>
						</v-container>
					</div>
					
					<div v-if="viewedDevice.id === 0x0f43">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/HW_app_moni-high-quality.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/HW_app_moni.jpg" />
							</picture>
							<!-- TODO: Add alt tags to the images -->

							<p class="p-p">Urządzenie wentylacyjne marki Alnor, fabrycznie kompatybilne z HAQCS, dzięki czemu wentyluje w pełni automatycznie, zgodnie z zapotrzebowaniem i optymalnie oszczędza energię grzewczą. Dla rozwiązań budżetowych może być także sterowane ręcznie za pomocą aplikacji na smartfona.</p>

							<h2>Zalety:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Zgodność z HAQCS - automatyczna regulacja wentylacji na podstawie pomiarów jakości powietrza w pomieszczeniu, we współpracy z monitorem HAQCS.</li>
									<li>Łatwy montaż w ścianach zewnętrznych przy minimalnym okablowaniu.</li>
									<li>Wysoka wydajność: 20, 40 i 60 m³/h powietrza.</li>
									<li>Wbudowany czujnik wilgotności do automatycznego odwilgocania w razie potrzeby.</li>
									<li>Ciche działanie.</li>
									<li>Darmowa aplikacja do sterowania.</li>
									<li>Łatwe do czyszczenia.</li>
								</ul>
							</p>
							
							<h2>Sterowanie</h2>
							<p class="p-p">Sterowane przez monitor HAQCS na podstawie danych z jego czujników. Zawsze świeże powietrze zgodnie z zapotrzebowaniem i oszczędność energii. Automatycznie.</p>
							<p class="p-p">Alternatywnie, ręczne sterowanie za pomocą bezpłatnej aplikacji WallAIR..</p>
							
							<h2>Obsługa od wewnątrz</h2>
							<p class="p-p">Wszystkie prace serwisowe i konserwacyjne można łatwo i ekonomicznie wykonywać od wewnątrz. Nie ma potrzeby stosowania rusztowań zewnętrznych.</p>

							<h2>Dane techniczne</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Dane techniczne</div>
									<div class="value">20, 40, 60 m³/h</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Grubość ściany zewnętrznej:</div>
									<div class="value">200 – 560 mm</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Zużycie energii:</div>
									<div class="value">1,4 – 3,8 watów</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Poziom ciśnienia akustycznego (3 m):</div>
									<div class="value">10 – 26 dB(A)</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Izolacja dźwiękowa od zewnątrz:</div>
									<div class="value">39 dB (odpowiada klasie okna 3 według VDI 2719)</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Odzysk ciepła:</div>
									<div class="value">Max. 82%, Średnio 74,3%</div>
								</div>
							</div>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0x7b90">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/marley-MEnV-HAQCS-edition.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/marley-MEnV-HAQCS-edition.png" />
							</picture>

							<p class="p-p">Następca popularnego modelu Marley MEnV 180. Urządzenie jest kompatybilne z HAQCS. </p>

							<h2>Funkcje:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Komunikuje się z monitorem HAQCS i jest regulowany przez ten monitor</li>
									<li>Pokazuje aktualną intensywność wentylacji za pomocą kolorowej diody LED</li>
									<li>Wymaga monitora HAQCS do kontroli</li>
									<li>Posiada filtry G3 i G2, opcjonalnie nawet filtry F7</li>
									<li>Wszystkie czynności serwisowe można wykonywać od wewnątrz</li>
									<li>Automatycznie kontroluje jasność wyświetlacza</li>
								</ul>
							</p>

							<h2>Dane techniczne:</h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter">Przepływ powietrza</div>
									<div class="value">16–25 lub 37 m³ / h w zależności od poziomu</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Pobór mocy</div>
									<div class="value">3,5 - 5,0 - 7,5 watów w zależności od poziomu</div>
								</div>
								<div class="table table-even">
									<div class="parameter">Głośność</div>
									<div class="value">22 - 29 - 35 dB(A) w zależności od poziomu</div>
								</div>
								<div class="table table-uneven">
									<div class="parameter">Odzysk ciepła</div>
									<div class="value">Maks. 85%, średnio 79,1%</div>
								</div>
							</div>

							<h2>Zakres dostawy:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Marley MEnV Edycja HAQCS</li>
									<li>Zestaw filtrów na 2 lata</li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0x217d">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/upgrade-marley-MEnV180.webp" type="image/webp" />
								<img class="p-img" src="../../static/img/offer/upgrade-marley-MEnV180.jpg" />
							</picture>

							<p class="p-p">Zestaw płytek sterownika do popularnych urządzeń wentylacyjnych z odzyskiem ciepła Marley MEnV 180. Po wymianie płytek urządzenia stają się kompatybilne z HAQCS i mogą być sterowane automatycznie przez HAQCS-Monitor odpowiednio do rzeczywistych potrzeb.</p>

							<h2>Funkcje:</h2>
							<p class="p-p">
								<ul class="narrow">
									<li>Komunikuje się z monitorem HAQCS</li>
									<li>Kontroluje diodę LED wentylatora i wskaźnika</li>
									<li>Monitoruje czas pracy i przypomina, aby zmienić filtr</li>
								</ul>
							</p>

							<h2> Dane techniczne: </h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter"> Pobór mocy </div>
									<div class="value"> 0,30 - 0,35 W w trybie czuwania </div>
								</div>
							</div>

							<h2> Zakres dostawy: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Sterowanie dla 2 urządzeń </li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0xacdc">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/upgrade-prana150-200.webp" type="image/webp" />
								<img class="p-img" src="../../static/img/offer/upgrade-prana150-200.jpg" />
							</picture>

							<p class="p-p"> Płyta sterująca do zdecentralizowanych urządzeń wentylacyjnych z odzyskiem ciepła Prana 150, 200C, 200G. Po wymianie płytki urządzenia stają się kompatybilne z HAQCS i mogą być kontrolowane automatycznie w zależności od potrzeb przez monitor HAQCS. </p>

							<h2> Funkcje: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Komunikuje się z monitorem HAQCS lub pilotem zdalnego sterowania </li>
									<li> Kontroluje wentylatory </li>
									<li> Umożliwia wszystkie tryby automatyczne, sterowanie ręczne, tryb nocny, tryb intensywny i tryb letni </li>
									<li> Wyświetla intensywność wentylacji w krokach co 1% </li>
									<li> Automatycznie kontroluje jasność wyświetlacza </li>
								</ul>
							</p>

							<!-- <h2> Dane techniczne: </h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter"> Pobór mocy </div>
									<div class="value"> 0,30 - 0,35 W w trybie czuwania </div>
								</div>
							</div> -->

							<h2> Zakres dostawy: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Sterowanie dla 1 urządzenia </li>
								</ul>
							</p>
						</v-container>
					</div>

					<div v-if="viewedDevice.id === 0x75ab">
						<v-container>
							<picture>
								<source srcset="../../static/img/offer/Unibox.webp" type="image/webp" />
								<img class="p-img no-shadow" src="../../static/img/offer/Unibox.png" />
							</picture>

							<p class="p-p"> Sterownik mocy dla prostych wentylatorów wyciągowych na 230 V, które nie mają własnej regulacji i sterowania. Unibox jest wpinany w przewód zasilający wentylatora.</p>

							<h2> Funkcje: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> Komunikuje się z monitorem HAQCS </li>
									<li> Kontroluje podłączone wentylatory </li>
									<li> Wyświetla aktualną intensywność wentylacji w krokach co 1% </li>
									<li>Automatycznie kontroluje jasność wyświetlacza </li>
								</ul>
							</p>

							<h2> Dane techniczne: </h2>
							<div class="table-container_">
								<div class="table table-even">
									<div class="parameter"> Moc kontrolna </div>
									<div class="value"> Max: 150 W </div>
								</div>
								<div class="table table-uneven">
									<div class="parameter"> Napięcie wejściowe </div>
									<div class="value"> 230 V, 110 V </div>
								</div>
								<div class="table table-even">
									<div class="parameter"> Częstotliwość </div>
									<div class="value">50 Hz, 60 Hz</div>
								</div>
							</div>

							<h2> Zakres dostawy: </h2>
							<p class="p-p">
								<ul class="narrow">
									<li> HAQCS Unibox z materiałem montażowym </li>
								</ul>
							</p>
						</v-container>
					</div>
				</div>
			</div>
		</v-container>
		<div style="height:50vh" />
	</div>
</template>

<script>
export default {
	name: 'Angebot',
	created: function() {
		this.updateLng();
	},
	mounted: function() {
		this.unwatchLanguage = this.$watch('language', () => { this.updateLng(); this.updateViewedDevice(); });
		this.unwatchViewedDevice = this.$watch('$route.params.viewedDevice', this.updateViewedDevice);
		this.updateViewedDevice();
	},
	beforeDestroy() {
		this.unwatchLanguage();
		this.unwatchViewedDevice();
	},
	data () {
		return {
			deviceList: {
				en: {
					"HAQCS-Monitor": { title: "HAQCS-Monitor", id: 0xa778 },
					"Ambientika-AUTO": { title: "Ambientika AUTO", id: 0x1bcf },
					"HRU-WALL-WI": { title: "HRU-WALL-WI", id: 0x0f43 },
					"Marley-MEnV-HAQCS-Edition": { title: "Marley MEnV HAQCS Edition", id: 0x7b90 },
					"Upgrade-Marley-MEnV-180": { title: "Upgrade for Marley MEnV 180", id: 0x217d },
					"Upgrade-Prana-150-200": { title: "Upgrade for Prana 150 / 200", id: 0xacdc },
					"HAQCS-Unibox": { title: "HAQCS-Unibox", id: 0x75ab },
				},
				de: {
					"HAQCS-Monitor": { title: "HAQCS-Monitor", id: 0xa778 },
					"Ambientika-AUTO": { title: "Ambientika AUTO", id: 0x1bcf },
					"HRU-WALL-WI": { title: "HRU-WALL-WI", id: 0x0f43 },
					"Marley-MEnV-HAQCS-Edition": { title: "Marley MEnV HAQCS Edition", id: 0x7b90 },
					"Upgrade-Marley-MEnV-180": { title: "Upgrade für Marley MEnV 180 auf HAQCS", id: 0x217d },
					"Upgrade-Prana-150-200": { title: "Upgrade für Prana 150 / 200", id: 0xacdc },
					"HAQCS-Unibox": { title: "HAQCS-Unibox", id: 0x75ab },
				},
				pl: {
					"HAQCS-Monitor": { title: "HAQCS-Monitor", id: 0xa778 },
					"Ambientika-AUTO": { title: "Ambientika AUTO", id: 0x1bcf },
					"HRU-WALL-WI": { title: "HRU-WALL-WI", id: 0x0f43 },
					"Marley-MEnV-Edycja-HAQCS": { title: "Marley MEnV Edycja HAQCS", id: 0x7b90 },
					"Ulepszenie-Marley-MEnV-180": { title: "Ulepszenie dla Marley MEnV 180", id: 0x217d },
					"Ulepszenie-Prana-150-200": { title: "Ulepszenie dla Prana 150 / 200", id: 0xacdc },
					"HAQCS-Unibox": { title: "HAQCS-Unibox", id: 0x75ab },
				},
			},
			idList: {},
			buildIdList: function(lang) {
				if (this.idList.hasOwnProperty(lang)) {
					return;
				}

				let idList = {};
				for (let [path, deviceInfo] of Object.entries(this.deviceList[lang])) {
					idList[deviceInfo.id] = path;
				}

				this.idList[lang] = idList;
			},
			getPathFromId: function(id, lang) {
				this.buildIdList(lang);
				return this.idList[lang][id];
			},
			viewedDevice: { param: '', title: '', id: 0 },
			isAlreadyViewingDevice: function() {
				return this.viewedDevice.id !== 0 && this.$route.params.viewedDevice !== undefined;
			},
			updateViewedDevice: function() {
				if (this.isAlreadyViewingDevice()) {
					let id = this.viewedDevice.id;
					let path = this.lng.listPath + '/' + this.getPathFromId(id, this.language);
					this.$router.replace(path);
				}

				let viewedDevice = this.$route.params.viewedDevice;
				if (this.deviceList[this.language].hasOwnProperty(viewedDevice)) {
					let deviceInfo = this.deviceList[this.language][viewedDevice];
					this.viewedDevice = { param: viewedDevice, title: deviceInfo.title, id: deviceInfo.id };
				} else {
					this.viewedDevice = { param: '', title: this.lng.title, id: 0 };
				}
			},
			scrollTo: function(element) {
				let options = {
					// container: 'body',
					container: '#frame',
					easing: 'ease',
					offset: -64,
					force: true,
					cancelable: false,
					onStart: false,
					onDone: false,
					onCancel: false,
					x: true,
					y: true
				};

				let duration = 700;

				this.$scrollTo(element, duration, options);
			},
			scrollToTop: function() {
				document.getElementById('frame').scrollTop = 0;
			},


			// language
			updateLng: function() {
			    this.lng = this.messages[this.language];
			},
			lng: {},
			messages: {
			    en: {
					listPath: '/offer',
					title: 'Our Offer',
					description: {
						"": "The offer of the company Haplabit.",
						"HAQCS-Monitor": 'Air quality monitor and controller for decentralized ventilation and humidification.',
						"Marley-MEnV-HAQCS-Edition": 'Successor to the popular Marley MEnV 180 model. The HAQCS edition has HAQCS compatibility.',
						"Upgrade-Marley-MEnV-180": 'Set of control boards for the popular ventilation units with heat recovery Marley MEnV 180. After replacing the boards, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor.',
						"Upgrade-Prana-150-200": 'Control board for the decentralized ventilation units with heat recovery Prana 150, 200C, 200G. After replacing the board, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor.',
						"HAQCS-Unibox": 'Power controller for simple exhaust fans for 230 V, which do not have their own regulation and control. The power supply to the fan is looped through the Unibox.',
					},
					back: 'back',
			    },
			    de: {
					listPath: '/angebot',
					title: 'Unser Angebot',
					description: {
						"": "Das Angebot der Firma Haplabit.",
						"HAQCS-Monitor": 'Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO2, VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung.',
						"Marley-MEnV-HAQCS-Edition": 'Nachfolger des populären Modells Marley MEnV 180. Die HAQCS-Edition verfügt über HAQCS-kompatibilität.',
						"Upgrade-Marley-MEnV-180": 'Satz Steuerplatinen für die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180. Nach Austausch der Platinen werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.',
						"Upgrade-Prana-150-200": 'Steuerplatine für die dezentralen Lüftungsgeräte mit Wärmerückgewinnung Prana 150, 200C, 200G. Nach Austausch der Platine werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.',
						"HAQCS-Unibox": 'Leistungsregler für einfache Abluftventilatoren für 230 V, die keine eigene Regelung und Steuerung besitzen. Die Stromversorgung zum Ventilator wird durch die Unibox durchgeschleift.',
					},
					back: 'zurück',
				},
				pl: {
					listPath: '/oferta',
					title: 'Nasza oferta',
					description: {
						"": "Oferta firmy Haplabit.",
						"HAQCS-Monitor": 'Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.',
						"Marley-MEnV-Edycja-HAQCS": 'Następca popularnego modelu Marley MEnV 180. Urządzenie jest kompatybilne z HAQCS.',
						"Ulepszenie-Marley-MEnV-180": 'Zestaw płytek sterownika do popularnych urządzeń wentylacyjnych z odzyskiem ciepła Marley MEnV 180. Po wymianie płytek urządzenia stają się kompatybilne z HAQCS i mogą być sterowane automatycznie przez HAQCS-Monitor odpowiednio do rzeczywistych potrzeb.',
						"Ulepszenie-Prana-150-200": 'Centrala sterująca do zdecentralizowanych urządzeń wentylacyjnych z odzyskiem ciepła Prana 150, 200C, 200G. Po wymianie płytki urządzenia stają się kompatybilne z HAQCS i mogą być kontrolowane automatycznie w zależności od potrzeb przez HAQCS-Monitor.',
						"HAQCS-Unibox": 'Regulator wydajności dla prostych wentylatorów wyciągowych na 230 V, które nie mają własnej regulacji i sterowania. Unibox jest wpinany w przewód zasilający wentylatora.',
					},
					back: 'powrót',
			    }
			},
			
			getMetaDescription: function() {
				if (this.lng.description === undefined) {
					this.updateLng();
				}

				return this.lng.description[this.viewedDevice.param];
			},
		}
	},
	props: [ 'language' ],
	metaInfo() {
		return {
			title: this.lng.title,
			// title: "Dokumentation",
			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
			    lang: this.language,
			},
			meta: [
			    { name: 'description', content: this.getMetaDescription() },
			    { name: 'theme-color', content: '#00c853' }
			]
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	background-color: white;
	padding: 8px;
}

h1 {
	color: black;
	font-size: 2.2rem;
	font-weight: bold;
	font-family: Arial, Helvetica, sans-serif;
	margin-top: 8px;
	/* margin-bottom: -32px; */
	padding-left: 128px;
	padding-right: 128px;
	text-align: center;
}

.back-button {
	position: absolute;
}

@media screen and (max-width: 599px) {
	h1 {
		padding-left: 4px;
		padding-right: 4px;
	}

	.back-button {
		position: relative;
	}
}

h2 {
	padding-top: 48px;
	margin-bottom: 8px;
	color: black;
	/* font-size: 2rem; */
	font-size: 1.2rem;
	/* font-weight: 100; */
	font-weight: 700;
	font-family: Arial, Helvetica, sans-serif;
}

h3 {
	padding-top: 32px;
	margin-bottom: 4px;
	color: black;
	font-size: 1.8rem;
	font-weight: 100;
	font-family: Arial, Helvetica, sans-serif;
}

h4 {
	padding-top: 24px;
	margin-bottom: 2px;
	color: black;
	font-size: 1.5rem;
	font-weight: 100;
	font-family: Arial, Helvetica, sans-serif;
}

.tile {
	display: flex;
	/* justify-content: space-between; */

	padding: 16px;
	border-radius: 8px;
	margin-bottom: 32px;

	background-color: rgb(245, 245, 245);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.0);
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;

	cursor: pointer;

	transition: 0.2s;
}

.tile:hover {
	background-color: rgb(240, 239, 239);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.tile:active {
	background-color: rgb(228, 228, 228);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.tile img {
	order: 0;
	width: 180px;
}

.tile .text-container_ {
	order: 1;
	flex-grow: 100;
	padding-left: 24px;
}

.tile .text-container_ .text {
	position: relative;
	top: 50%;
	transform: translateY(-50%);
	text-align: left;
}

.tile .icon-container_ {
	order: 2;
}

.tile .icon-container_ .icon {
	height: 100%;
	padding-left: 8px;
	transform: translateX(8px) scale(0.8);
	opacity: 0.0;
}

.tile:hover .icon-container_ .icon {
	transform: translateX(0px) scale(1.0);
	opacity: 1.0;
}

@media screen and (max-width: 599px) {
	.tile {
		flex-direction: column;
	}

	.tile img {
		height: 100%;
		width: 100%;
	}

	.tile .text-container_ .text {
		transform: translateY(0);
	}

	.tile .icon-container_ .icon {
		right: 0;
	}
}

.tile .text .device-title {
	font-weight: 700;
	font-size: 16px;
	padding-bottom: 8px;
}

@media screen and (min-width: 600px) {
	.tile .haqcs-height {
		height: 153px;
	}
	
	.tile .ambientika-auto-height {
		height: 108px;
	}
	
	.tile .hru-wall-wi-height {
		height: 100px;
	}

	.tile .marley-haqcs-edition-height {
		height: 69px;
	}

	.tile .upgrade-marley-menv-180-height {
		height: 119px;
	}

	.tile .upgrade-prana-150-200-height {
		height: 120px;
	}

	.tile .unibox-height {
		height: 305px;
	}
}

.table-container_ {
	margin-bottom: 32px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.table-container_ .table {
	display: flex;
	padding: 4px;
}

@media screen and (max-width: 500px) {
	.table-container_ .table {
		flex-direction: column;
	}
}

.table-container_ .table-even {
	background-color: rgb(248, 248, 248);
}

.table-container_ .table-uneven {
	background-color: rgb(241, 241, 241);
}

.table-container_ .table .parameter {
	order: 0;
	width: 180px;
	border-color: black;
	font-weight: bold;
	padding-left: 4px;
}

.table-container_ .table .value {
	order: 1;
	flex-shrink: 100;
	padding-left: 4px;
	padding-right: 4px;
}

ul {
	margin-top: 8px;
	padding-bottom: 16px;
}

ol {
	margin-top: 8px;
	padding-bottom: 16px;
}

li {
	padding-bottom: 8px;
}

.narrow {
	padding-bottom: 0;
}

.narrow li {
	padding-bottom: 0;
}

.p-p {
	/* text-align: justify; */
	text-align: left;
}

.p-img {
	display: block;
	margin-left: auto;
	margin-right: auto;
	margin-top: 8px;
	margin-bottom: 32px;
	box-shadow: 0 2px 4px rgb(0, 0, 0, 0.38);
	max-width: 100%;
	max-height: 100%;
}

.no-shadow {
	box-shadow: 0 0 0 rgb(0, 0, 0, 0);
}

.link {
	cursor: pointer;
	color:rgb(11, 112, 180);
}

.link:hover {
	color:rgb(8, 87, 139);
	text-decoration: underline;
}

.message {
	margin: 12px 5%;
	text-align: left;
}

.between-headings {
	margin-top:-32px;
}

::selection {
	background: #A7F7A6;
}
</style>



// WEBPACK FOOTER //
// Angebot.vue?81f19b28